import { ApiService, GenericError} from './api-main'
import store from '../store';
import CryptoAES from 'aes-ecb'

const EkycService = {
    getEkycTypeList: async function() {
        const params = {
            occupation  : encodeURIComponent(store.state.customer.occupation),
            rbId        : store.state.misc.appBranchId,
            langCode    : "en",
        }
        const url = 'main/idtype/verify'
        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {params})
            return ApiService.validateResponse(response, '1032')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },

    uploadEkycDocs: async function(docTypeId, idNo, imageData) {

        const randVal = await ApiService.getRandomValue();
        var encryptedIdNo = idNo;
        if(idNo != '') {
            var secretKey  = process.env.VUE_APP_OPSTK+randVal;
            encryptedIdNo = encodeURIComponent(CryptoAES.encrypt(secretKey, idNo));
        }

        const params = {
            verifyType              : this.getVerifyType(docTypeId),
            identificationNo        : encryptedIdNo,
            identificationTypeId    : docTypeId,
            uploadedString64        : imageData,
            extString               : "jpg",
            retailBranchId          : store.state.misc.appBranchId,
        }
        const url = 'main/customer/ekyc'
        try {
            await ApiService.generateAuthClient(randVal);
            const response = await ApiService.post(url, params)
            return ApiService.validateResponse(response, '0809')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },

    getVerifyType: function(docTypeId){
        if(docTypeId == process.env.VUE_APP_DOCUMENT_ID_POA) return 2; // POA
        else return 1; // Other
    }
}

export default EkycService